/**
 * @generated SignedSource<<c64ac52c27130d077cc8196bc7114774>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CompositionCategoryUpdateInput = {
  categoryID?: number | null;
  displayOrder?: number | null;
  macroCategoryId: number;
  name: string;
};
export type presetConfigurationsQueriesUpdateCategoryMutation$variables = {
  input: CompositionCategoryUpdateInput;
};
export type presetConfigurationsQueriesUpdateCategoryMutation$data = {
  readonly updateCompositionCategory: {
    readonly categoryID: number;
    readonly displayOrder: number;
    readonly id: string;
    readonly name: string | null;
  };
};
export type presetConfigurationsQueriesUpdateCategoryMutation = {
  response: presetConfigurationsQueriesUpdateCategoryMutation$data;
  variables: presetConfigurationsQueriesUpdateCategoryMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "compositionCategory",
        "variableName": "input"
      }
    ],
    "concreteType": "CompositionCategory",
    "kind": "LinkedField",
    "name": "updateCompositionCategory",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "categoryID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "displayOrder",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "presetConfigurationsQueriesUpdateCategoryMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "presetConfigurationsQueriesUpdateCategoryMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "78a16f4e05692f794d3cb9ba97fac4c1",
    "id": null,
    "metadata": {},
    "name": "presetConfigurationsQueriesUpdateCategoryMutation",
    "operationKind": "mutation",
    "text": "mutation presetConfigurationsQueriesUpdateCategoryMutation(\n  $input: CompositionCategoryUpdateInput!\n) {\n  updateCompositionCategory(compositionCategory: $input) {\n    id\n    categoryID\n    name\n    displayOrder\n  }\n}\n"
  }
};
})();

(node as any).hash = "4b3204851dcec34ad01197b422e51062";

export default node;
